import InvestorMailbox from "./investor-mailbox";

export default InvestorMailbox;
